const pmProjects = [];
const pmTeamMembers = [];
const members = [];
const pmLeaveReqs = [];
const pmChatMessages = [];
const pmAnnouncements = [];
const pmHrReports = [];
const pmSchedules = [];
const PM_NAV = [
  {k:"dashboard",l:"Dashboard",i:"dash"},{k:"projects",l:"Projects",i:"bulk"},
  {k:"progress",l:"Team Progress",i:"users"},{k:"leave",l:"Leave Requests",i:"clock"},
  {k:"calendar",l:"Calendar",i:"calendar"},
  {k:"announce",l:"Announcements",i:"bell"},
  {k:"reports",l:"HR Reports",i:"chart"},{k:"hrrequests",l:"HR Requests",i:"note"},{k:"offboardingmanagement",l:"Offboarding Management",i:"logout"},{k:"chat",l:"Team Chat",i:"send"},
  {k:"permissions",l:"Permissions",i:"clock"},{k:"advances",l:"Salary Advances",i:"wallet"},{k:"notifications",l:"Notifications",i:"bell"},
  {k:"profile",l:"Profile",i:"user"},{k:"notes",l:"Notes",i:"note"},{k:"people",l:"People",i:"users"},
];
export { pmProjects, pmTeamMembers, members, pmLeaveReqs, pmChatMessages, pmAnnouncements, pmHrReports, pmSchedules, PM_NAV };
